const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/community-lab/session.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/community-lab/session")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    sessionId: z.enum(["SESSION_0", "SESSION_1", "SESSION_2", "SESSION_3", "SESSION_4", "SESSION_5", "SESSION_6", "SESSION_7", "SESSION_8", "SESSION_9", "SESSION_10", "SESSION_11", "SESSION_12", "SESSION_13", "SESSION_14"])
  }))
});